const userGlobalConfig = {
  ADMIN_DETAILS: "detail",
  TOKEN: "airkeyhub_admin_token",
  USER_TOKEN: "airkeyhub_UserToken",
  LANGUAGE: "airkeyhub_labguage",
};

export default userGlobalConfig;
